class Membro {
  _id: string;
  email?: string;
  deleted?: Boolean;
  new?: Boolean;
}

export class EquipeModel {
  nome: string;
  tipo?: string;
  supervisor: string;
  gestor: string;
  membros: Membro[];
  empresas: any[];
  deleted: Boolean;
  _id?: string;
  error?: string;
}
